import { useEffect, useState } from "react";
import { getTimeListArray } from "../../_util";

export default ({props, ref}) => {
  const { timeList, getVer, getValue } = props;
  const timeListArray = getTimeListArray(timeList);
  const [value1, setValue1] = useState("");
  const [maxSegmentPage, setMaxSegmentPage] = useState(2);
  const [dateNum, setDateNum] = useState(5);
  const [segmentPage, setSegmentPage] = useState(0);

  /**
   * @description: 日期选择改变
   * @param {*} val 新选择的日期值
   * @return {*}
   */
  const DateChange = (val) => {
    setValue1(val);
    getValue(val);
  };

  /**
   * @description: 日期选择框宽度改变，重新计算每次可展示的日期的数量和总页面，将已选择的日期设置为默认0
   * @return {*}
   */
  const handleResize = () =>{
    const pageNum = Math.floor(ref.current!.offsetWidth/130.0);
    setDateNum(pageNum);
    setMaxSegmentPage(Math.ceil(timeListArray.length/pageNum));
    setSegmentPage(0);
  };

  /**
   * @description: 日期列表改变，根据当前所选日期，如果列表中不存在该日期则设置为0
   * @return {*}
   */
  const handleTimeListChange = () => {
    const findVer = timeListArray.find((obj) => obj.value === getVer);
    if (getVer != "" && findVer) {
      setValue1(getVer);
      DateChange(getVer);
    } else {
      setValue1(timeListArray[0].value);
      DateChange(timeListArray[0].value);
    }
  };

  /**
   * @description: 所选的游戏改变，日期改变
   * @return {*}
   */
  useEffect(() => {
    handleResize();
    handleTimeListChange();
    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [timeList]);

  return {
    timeListArray,
    value1,
    maxSegmentPage,
    dateNum,
    segmentPage,
    setSegmentPage,
    DateChange,
    handleResize
  };
};
